import { AvailableLanguage } from './available-language';


export const DEFAULT_LANG: AvailableLanguage = AvailableLanguage.EnGb;
export const DATE_CALENDAR_FORMAT: string = 'YYYY-MM-DD';
export const DATE_TIME_FNS_DB_FORMAT: string = 'yyyy-MM-dd\'T\'HH:mm:ss';
export const DATE_FNS_DB_FORMAT: string = 'yyyy-MM-dd';
export const TIME_FORMAT: Record<AvailableLanguage, string> = {
    [AvailableLanguage.RuRu]: 'HH:mm',
    [AvailableLanguage.EnGb]: 'HH:mm',
    [AvailableLanguage.FrFr]: 'HH:mm',
    [AvailableLanguage.EsEs]: 'HH:mm',
    [AvailableLanguage.EnUs]: 'hh:mm a',
};
